import React, { memo } from "react";
import PropTypes from "prop-types";
import { ButtonRoot } from "./elements";

export const BettoPrimaryButton = memo(
	({ children, variant = "primary", size, fullWidth, ...rest }) => (
		<ButtonRoot $variant={variant} $size={size} $fullWidth={fullWidth} {...rest}>
			{children}
		</ButtonRoot>
	)
);

BettoPrimaryButton.displayName = "BettoPrimaryButton";

BettoPrimaryButton.propTypes = {
	children: PropTypes.node,
	variant: PropTypes.oneOf(["primary", "secondary", "ghost"]),
	size: PropTypes.oneOf(["sm", "md"]),
	fullWidth: PropTypes.bool,
};
